
import React, { useContext, useEffect, useState } from 'react'
import { useLocation,useHistory,useRouteMatch } from 'react-router-dom'
import { ListGroup,ListGroupItem,Button } from 'react-bootstrap'
import httpClient from 'utility/httpClient.util'
import moment from 'moment'
import { useTimeFormat } from 'contexts/TimeFormatContext'
const tableList = [
    {name:'2023-03-03',id:665553},
    {name:'2024-03-03',id:665554}
]

const VisitNavigation = () => {
    const {formatDate} = useTimeFormat();
    const [activeGroup,setActiveGroup] = useState({id:0})
    const [visitList,setVisitList] = useState([])


    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const hn = queryParams.get('hn');
    const vn = queryParams.get('vn');
    const an = queryParams.get('an');   
    const baseUrl = window.location.href.split('#')[0];
    const [hashPath, existingSearchParams] = window.location.hash.split('?');
    useEffect(async ()=>{
       
        //const data = [{an:'991010171001',visitDate:'2023-10-11'},{an:'991010171002',visitDate:'2023-11-11'}]
        if(hn){
            const data = (await httpClient
            .get(`/ipd/in-patient-admit/history/${hn}`)
            .then(({ data }) => data.data)) || []
            if (data) {
                const sortedData = data.sort((a, b) => new Date(b.checkInDate) - new Date(a.checkInDate));
                const activeAn = sortedData.find(({isDischarge})=>isDischarge*1===0) || {an:''}
                
                setVisitList(sortedData.map((ipd)=>{
                    const visitDate = formatDate(ipd.checkInDate)//.format('YYYY-MM-DD')
                    let title =  ipd.isDischarge*1===0 ?  `Active` : visitDate               
                    const visitItem = {...ipd,id:ipd.an,activeAn:activeAn.an,visitDate:visitDate,name:title}
                    if(an===ipd.an){
                        
                        setActiveGroup(visitItem)
                    }
                    return visitItem
                }))        
            }    
        }

    },[location])

    const getLinkUrl = (item)=>{
        
    
    // Create a URLSearchParams object from the existing parameters
        const newParams = new URLSearchParams(existingSearchParams);

        // Construct new query parameters
        //const newParams = new URLSearchParams();
        if (item.an) newParams.set('an', item.an);
        if (item.hn) newParams.set('hn', item.hn);
        if (item.vn) newParams.set('vn', item.vn);
        if(item.an ===item.activeAn)
            newParams.delete('readonly')          
        else
            newParams.set('readonly','true')
            

        // Construct the new hash portion of the URL
        
        let newHashPath = hashPath
        

        const newHash = `${newHashPath}?${newParams.toString()}`;
        const newUrl = `${baseUrl}${newHash}`;
        //console.log('new',newHash,newUrl)
        history.push({
            search: `?${newParams.toString()}` // should be a query string starting with `?`
          });
        return newUrl
    }

    const onGroupClick = (item,index)=>{
        setActiveGroup(item)
        //Navigate
        // Parse the current URL
        // Extract the base URL and parameters
        const newUrl = getLinkUrl(item)
        //window.location = newUrl
        
        //console.log('route',newUrl)
        // Navigate to the new URL
        //window.location.href = `${newUrl}`;
        // // Use your SPA framework/router's method to navigate without reloading the page
        // // For example, if you're using React Router:
        //history.push(newHash);
        
        // // Or just update the URL (without navigation)
        //window.history.pushState({}, '', newUrl);
    }

    if(!hn){
        const menuSub = document.querySelector('.menu-sub-level')
        if (menuSub) { // Check if the element exists
            menuSub.classList.remove('menu-sub-level');
            document.querySelector('.has-multi-level-menu').classList.remove('has-multi-level-menu')            
        }
        
        return null
    }
    
    return (
        <div className='menu-main-level p-1'>
         <ListGroup            
            className="rounded-0"
          >
            <ListGroupItem className='text-center'>
                {/* <Button
                    color="primary"
                    className="px-1 py-50"
                    outline                    
                >
                    <i className="feather icon-arrow-down-left pr-50"></i>
                    Hide Menu
                </Button> */}
                EMR List
            </ListGroupItem>             
            {visitList.map((item, index) => (
              <ListGroupItem
                key={index}
                onClick={async (e) => {
                  await onGroupClick(item, index);
                }}
                action
                className={activeGroup?.id===item.id ? 'item-active' : ''}
              >                
                {item.name} 
                {/* {activeGroup?.id===item.id && (<span className="fas fa-arrow-right m-l-10"></span>) } */}
              </ListGroupItem>
            ))}           
          </ListGroup>
          

        </div>
    )
}
export default VisitNavigation